module.exports = __webpack_public_path__ + "img/sensor-cloud.af794a10.svg";